import type { ModuleNavigation } from '../../layouts/ModuleSidebar';

export const livestockNavigation: ModuleNavigation = [
  {
    title: 'Overview',
    items: [
      { path: '/livestock/dashboard', label: 'Dashboard' },
    ],
  },
  {
    title: 'Entities',
    items: [
      { path: '/livestock/admin/animals', label: 'Animal' },
      { path: '/livestock/admin/birth-records', label: 'Birth Record' },
      { path: '/livestock/admin/breeding-records', label: 'Breeding Record' },
      { path: '/livestock/admin/compliance-reports', label: 'Compliance Report' },
      { path: '/livestock/admin/farms', label: 'Farm' },
      { path: '/livestock/admin/feed-inventories', label: 'Feed Inventory' },
      { path: '/livestock/admin/financial-transactions', label: 'Financial Transaction' },
      { path: '/livestock/admin/health-events', label: 'Health Event' },
      { path: '/livestock/admin/medication-stocks', label: 'Medication Stock' },
      { path: '/livestock/admin/milk-records', label: 'Milk Record' },
      { path: '/livestock/admin/movements', label: 'Movement' },
      { path: '/livestock/admin/paddocks', label: 'Paddock' },
      { path: '/livestock/admin/tasks', label: 'Task' },
      { path: '/livestock/admin/treatments', label: 'Treatment' },
      { path: '/livestock/admin/weight-records', label: 'Weight Record' },
    ],
  },
];
